module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou13-143c141693fa0c5591465104211bd773.jpg";